import { DataService } from "@/services/data";
import { ProfessionDisplayType } from "@/types/content/registration/profession";
import { UserType } from "@/types/user";
import { RouteObject } from "react-router-dom";

const PicklistRoute: RouteObject = {
    path: "picklists",
    children: [
        {
            path: "agents",
            loader: async () => {
                const agents = (await DataService.client.url(`/medrep/contacts/agents/`).get().json()) as UserType[];
                return agents;
            }
        },
        {
            path: "professions",
            loader: async () => {
                const professions = (await DataService.client.url(`/medrep/contacts/professions/`).get().json()) as ProfessionDisplayType[];
                return professions;
            }
        }
    ]
};

export default PicklistRoute;
